import { render, staticRenderFns } from "./verAdaptacion.vue?vue&type=template&id=4f8c57c2"
import script from "./verAdaptacion.vue?vue&type=script&lang=js"
export * from "./verAdaptacion.vue?vue&type=script&lang=js"
import style0 from "./verAdaptacion.vue?vue&type=style&index=0&id=4f8c57c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports